class Node {
    constructor(value, isRoot) {
        this.content = [];
        this.nodes = [];
        this.label = value;
        this.isRoot = isRoot;
    }
}

export default class Trie {
    constructor(value) {
        this.root = new Node(value, true);
    }
    add(demo) {
        // If path is not specfied, the demoType will be placed at the root
        if (!demo.path) {
            this.root.content.push(demo);
        }
        else {
            console.log("Path: " + demo.path)
            let path = demo.path.split('|');
            let it = this.root;
            let cnt = 0;
            path.forEach(word => {
                console.log("Looking for " + word + " in ", it.nodes)
                let found = it.nodes.findIndex(str => {
                    console.log("Is " + str.label + " == " + word)
                    return (str.label == word)
                });
                if (found === -1) {
                    console.log("Pushing -1 node?")
                    if (!cnt) {
                        console.log("Yes, Pushing -1 node")
                        it.nodes.push(new Node(word, false));
                        it = it.nodes[it.nodes.length - 1];
                    }
                }
                else {
                    console.log("Found node...")
                    it = it.nodes[found];
                }
                cnt++;
            });
            console.log("Pushing node into root: ", demo)
            it.content.push(demo);
        }
    }

    getRoot() {
        return this.root;
    }
}